<template>
    <vPartnerProductAccountComponent :postList="postList" v-if="flag"></vPartnerProductAccountComponent>
</template>
<script>
import vPartnerProductAccountComponent from '../../listComponent/basicdata/partnerProductAccount/partnerProductAccountComponent.vue';
export default {
    name: 'partnerProductAccountList',
    components: {
        vPartnerProductAccountComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,

                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>